import { isValidTimeZone } from "../utils/timeZone";
import { useGeotabClient } from "@/components/GeotabClientContext";

/**
 * The zone the audit works in: the Geotab user's setting (what MyGeotab itself displays),
 * falling back to the browser's zone. Days are cut and times printed in this zone so the page
 * matches Geotab's reports wherever the auditor's computer happens to be.
 */
export function useAuditTimeZone(): string {
  const { me } = useGeotabClient();
  const userZone = me?.timeZoneId;
  if (isValidTimeZone(userZone)) return userZone;
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
